import React from 'react';
import Widgets from '../Widgets';
import { AreaGraph, LegendIconic, LegendNumeric } from '../../../components';
import PropTypes from 'prop-types';
import { isEqual } from 'lodash';

import './WidgetAreaChart.css';

export default class WidgetAreaChart extends Widgets {
  static propTypes = {
    ...Widgets.propTypes,
    leftLegend: PropTypes.obj,
    rightLegend: PropTypes.obj
  }

  componentDidUpdate(props, state) {
    if (
      (!isEqual(this.props.filters, props.filters) || ((this.state && state) && !isEqual(this.state.extraFilters, state.extraFilters)) || this.props.shouldLoadData)
      && (this.props.filtersLoaded)
    ){
      return this.props.fetchData(this.props.filters, this.props.id);
    }
  }

  render() {
    if (this.props.loaded)
      return (
        <div className={this.props.className ? `${this.props.className} WidgetAreaChart` : 'WidgetAreaChart'} style={this.props.style}>
          <LegendIconic {...this.props.leftLegend} />
          <div style={{'width': '60%', 'float': 'left'}}>
            {this.props.graph && this.props.graph.length ? <LegendNumeric colorScheme={this.props.colorScheme} keys={['nUnsub', 'nNew', 'nResub']} size={[this.props.width * 0.8, 50]} className="widget-stack-legend" /> : null}
            <AreaGraph colorScheme={this.props.colorScheme} data={this.props.graph ? this.props.graph : []} size={[this.props.width * 0.6, this.props.height * 0.9]} />
          </div>
          <LegendIconic {...this.props.rightLegend} />
        </div>
      );
    else if (!this.props.loaded && this.props.filtersLoaded)
      return (
        <div className={this.props.className ? `${this.props.className} WidgetAreaChart` : 'WidgetAreaChart'} style={this.props.style}>
          <img src={`${process.env.PUBLIC_URL}/loading.svg`} />
        </div>
      );
    else
      return (
        <div className={this.props.className ? `${this.props.className} WidgetAreaChart` : 'WidgetAreaChart'} style={this.props.style}>
          <h1>select operator and service to see stats</h1>
        </div>
      );
  }
}



// WEBPACK FOOTER //
// ./src/components/Widgets/WidgetAreaChartComponent/WidgetAreaChart.js